import { Deserializable } from '../deserializable';
import { Product } from './product.model';

export class ProductSpecialFeature implements Deserializable {
  public ProductID: number;
  public SpecialFeatureName: string;
  public Product: Product;
  public Value: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    delete (this as any).$id;

    return this;
  }
}
